import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useEffect, useMemo } from 'react';
import { FileIcon } from '@fabric-app/icons/icons';
import { styled } from 'styled-components';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';

const FileName = styled.div.withConfig({
  displayName: "FileDisplay__FileName",
  componentId: "sc-f2f20dfe-0"
})([
  `overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:400;font-size:16px;line-height:19px;color:var(--fabric-color-text-tertiary);max-width:100%;text-align:center;overflow:hidden;padding:10px;background:var(--fabric-color-bg-tertiary);border-radius:8px;`
]);
const FileIconWrapper = styled.div.withConfig({
  displayName: "FileDisplay__FileIconWrapper",
  componentId: "sc-f2f20dfe-1"
})([
  `padding:10px 20px 15px 20px;border-radius:40px;`
]);
const File = styled.div.withConfig({
  displayName: "FileDisplay__File",
  componentId: "sc-f2f20dfe-2"
})([
  `display:flex;flex-direction:column;align-items:center;justify-content:center;width:fit-content;max-width:90%;flex-grow:0;flex-shrink:0;position:relative;gap:8px;&[data-scaled-down='true']{`,
  `{font-size:14px;}}&[data-clickable='true']{cursor:pointer;`,
  `{background:var(--fabric-color-bg-tertiary);}`,
  `{&:hover{`,
  `,`,
  `{background:rgb(128 128 128 / 12%);}}}&:active{`,
  `,`,
  `{background:rgb(128 128 128 / 24%);}}}&[data-compact='true']{`,
  `{padding:0;}gap:6px;`,
  `{padding:6px 8px;color:var(--fabric-color-text-quaternary);font-size:11px;font-style:normal;font-weight:500;line-height:normal;border-radius:8px;}}`
], FileName, FileName, mediaHover, FileName, FileIconWrapper, FileName, FileIconWrapper, FileIconWrapper, FileName);
const FileDisplay = ({ fileExtension, compact, fileName, children, hideFileName, onClick, scale = 1, nameWithoutExtension = false }) => {
  const nameWithExtension = fileName.includes(fileExtension ?? "") || nameWithoutExtension ? fileName : `${fileName}.${fileExtension}`;
  const zoomLevel = 1;
  const [forceRefresh, setForceRefresh] = React__default.useState(1);
  useEffect(() => {
    if (window.devicePixelRatio > 1) {
      setForceRefresh((prev) => prev + 1e-3);
    }
  }, []);
  useEffect(() => {
    setForceRefresh((prev) => prev + 1e-3);
  }, [
    zoomLevel
  ]);
  const fileIconSize = useMemo(() => {
    if (compact) return {
      width: 58 * scale * forceRefresh,
      height: 66 * scale * forceRefresh
    };
    return {
      width: 202 * scale * forceRefresh,
      height: 213 * scale * forceRefresh
    };
  }, [
    compact,
    scale,
    forceRefresh
  ]);
  const filenamePadding = useMemo(() => {
    if (scale < 1) return "6px 8px";
    if (compact) return void 0;
    return 10;
  }, [
    scale,
    compact
  ]);
  return /* @__PURE__ */ jsxs(File, {
    "data-scaled-down": scale < 1,
    "data-clickable": !!onClick,
    "data-compact": compact,
    onClick,
    children: [
      /* @__PURE__ */ jsxs(FileIconWrapper, {
        children: [
          /* @__PURE__ */ jsx(FileIcon, {
            width: fileIconSize.width,
            height: fileIconSize.height,
            extension: fileExtension?.replace(".", "") ?? "?"
          }),
          children
        ]
      }),
      !hideFileName && /* @__PURE__ */ jsx(FileName, {
        style: {
          padding: filenamePadding
        },
        children: /* @__PURE__ */ jsx("span", {
          children: nameWithExtension
        })
      })
    ]
  });
};

export { FileDisplay as default };
//# sourceMappingURL=FileDisplay.js.map
